export default "__VITE_ASSET__Av$sF_qP__"